// extracted by mini-css-extract-plugin
export default {"ebanner":"ki-z"};